<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="page_9"></a><strong>MORE CHEESE THAN LAMBEAU</strong></h3>
<p class="noindentb"><span class="small">LYRIC FROM SONG: <strong>“CHECK 1, 2”</strong> ON ALBUM: <strong>OUT OF BUSINESS</strong> BY ARTIST</span>: <strong>EPMD</strong></p>
<p class="noindent">The amount of money I have is much greater than the number of hats shaped like a type of milk-derived, protein-rich food worn by fans in support of the Green Bay Packers football team in their stadium in Wisconsin, a state known for its dairy products.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01ch06.vue?4a9e2b90